import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

let portalType = "";
function init() {
    portalType = $("#PortalType").val();

    $("#aPrintCourseHistory").click(printTrainingHistory);

    $("#TrainingSelectionPanel").on("click", ".history-option", function() {
        let url = "";
        const courseId = $(this).val();
        if (portalType === "Instructor") {
            url = "/Person/GetCourseHistory/" + courseId;
        } else {
            url =
                "/Person/GetTrainingDetailsByPersonAndCourseId/" +
                $("#personId").val() +
                "/" +
                courseId;
        }
        dataaccess
            .get({
                url: url
            })
            .done(function(result) {
                const course = result;
                $("#PanelName").text(course.courseName);
                $("#PanelCourseType").text(course.courseType);
                $("#PanelId").text(course.courseId);
                $("#PanelStartDate").text(new Date(course.startDate).toLocaleDateString("en-US"));
                $("#PanelEndDate").text(new Date(course.endDate).toLocaleDateString("en-US"));
                $("#PanelCourseFacility").text(course.facilityName);
                $("#PanelCourseEdition").text(course.courseEdition);
                $("#PanelRole").text(course.roleName);
                $("#PanelOutcome").text(course.outCome);

                $("#TrainingDetailsModal").modal("show");
            });
    });

    $("#ApplyFiltersBtn").click(function() {
        const yearMin = $("#yearMin").val() === "" ? 0 : $("#yearMin").val();
        const yearMax = $("#yearMax").val() === "" ? 0 : $("#yearMax").val();
        const verificationPeriod = $("input[name='options']:checked").val();
        //The slashes screw up the url and data
        const startDate = $("#highestRoleStartDate")
            .val()
            .replace(/[/]/g, "-");
        const endDate = $("#highestRoleEndDate")
            .val()
            .replace(/[/]/g, "-");
        populateTrainingHistory(yearMin, yearMax, verificationPeriod, startDate, endDate);
    }); //sets values for training history with filters

    $("[name='options']").on("change", function() {
        if ($(this).val() === "Current") {
            $("#yearMin")
                .val("")
                .prop("readonly", true);
            $("#yearMax")
                .val("")
                .prop("readonly", true);
        } else {
            $("#yearMin").prop("readonly", false);
            $("#yearMax").prop("readonly", false);
        }
    });
    if (
        $("#highestReverificationRoleStartDate").val() === "undefined" &&
        $("#highestReverificationRoleEndDate").val() === "undefined"
    ) {
        const startDate = $("#highestReverificationRoleStartDate")
            .val()
            .replace(/[/]/g, "-");
        const endDate = $("#highestReverificationRoleEndDate")
            .val()
            .replace(/[/]/g, "-");
        populateTrainingHistory(0, 3000, "Current", startDate, endDate); //Initiates Data with Defaults
    }
    $("#yearMin")
        .val("")
        .attr("readonly", "readonly");
    $("#yearMax")
        .val("")
        .attr("readonly", "readonly");
}

function populateTrainingHistory(minYear, maxYear, verificationPeriod, startDate, endDate, role) {
    let url = "";
    if (portalType === "Person") {
        url =
            "/Person/GetPersonCoursesByIdWithFilters/" +
            $("#personId").val() +
            "/" +
            minYear +
            "/" +
            maxYear +
            "/" +
            verificationPeriod +
            "/" +
            startDate +
            "/" +
            endDate;
    } else {
        url =
            "/Person/GetPersonCoursesByIdWithFilters/" +
            minYear +
            "/" +
            maxYear +
            "/" +
            verificationPeriod +
            "/" +
            startDate +
            "/" +
            endDate;
    }
    dataaccess
        .get({
            url: url
        })
        .done(function(result) {
            const courses = result;
            $("#TrainingSelectionPanel").empty();
            if (!courses.length > 0) {
                $("#TrainingSelectionPanel").append(
                    "<div class='col-12 p-3 text-center'>There are no courses</div>"
                );
                return;
            }

            let html = "";
            courses.forEach(function(elm) {
                html +=
                    "<p>" + elm.programDescription + " " + elm.courseType + "</p>" +
                    "<p class='small muted'>" + elm.cityState + "</p>" +
                    "<div><i class='fa fa-calendar mr-1'></i>" + elm.startDateUtc + "<button class='btn btn-primary btn-sm mt-0 ml-4 history-option' value='" + elm.courseId + "'>View</button></div>" +
                    "<hr/>";
            });
            $("#TrainingSelectionPanel").html(html);
        });
    $("#TrainingDetailsPanel").addClass("hidden");
}

function printTrainingHistory() {
    const yearMin = $("#yearMin").val() === "" ? 0 : $("#yearMin").val();
    const yearMax = $("#yearMax").val() === "" ? 0 : $("#yearMax").val();
    const verificationPeriod = $("input[name='options']:checked").val();
    //The slashes screw up the url and data
    const startDate = $("#highestReverificationRoleStartDate")
        .val()
        .replace(/[/]/g, "-");
    const endDate = $("#highestReverificationRoleEndDate")
        .val()
        .replace(/[/]/g, "-");
    let url = "";
    if (portalType === "Instructor") {
        url =
            "/Person/PrintCourseHistory/" +
            yearMin +
            "/" +
            yearMax +
            "/" +
            verificationPeriod +
            "/" +
            startDate +
            "/" +
            endDate;
    } else {
        url =
            "/Person/PrintCourseHistory/" +
            $("#personId").val() +
            "/" +
            yearMin +
            "/" +
            yearMax +
            "/" +
            verificationPeriod +
            "/" +
            startDate +
            "/" +
            endDate;
    }
    forms.openPrintWindow(url);
}

export const courseHistory = {
    init: init,
    printTrainingHistory: printTrainingHistory
};
